import { registerBrick, Query, File as OFile, BrickContext } from 'olympe';
import { ReactBrick, useProperty } from '@olympeio/core';
import React from 'react';
import Page from '../../models/Page';

export default class HomeTiles extends ReactBrick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array<*>} properties
     * @returns {Element}
     */

    static getReactComponent($) {
        return (props) => {
            const pages = useProperty($, 'Pages');
            const [images, setImages] = React.useState(new Map());

            React.useEffect(async () => {
                // Download the tile images at load time and if the tiles changes
                const newImages = new Map();
                const getFileUrl = async (tag) => {
                    if (!tag) {
                        return;
                    }
                    const file = (await Query.fromTag(tag, OFile).execute()).getFirst();
                    if (!file) {
                        return;
                    }
                    const imageUrl = await new Promise((resolve, reject) => {
                        file.getContentUrl((url) => {
                            resolve(url);
                        }, reject);
                    });
                    newImages.set(tag, imageUrl);
                };

                await Promise.all((pages || []).map((page) => getFileUrl(page.get(Page.imageTagProp))));
                setImages(() => newImages);
            }, [pages]);

            let currentMainCategory = '';
            let currentSecondaryCategory = '';

            const getCircle = () => {
                return <div className="circle"></div>;
            };

            /**
             *
             * @param {Page} page
             * @returns {React.JSX}
             */
            const getMainCategoryIfNecessary = (page) => {
                const tileMainCategory = page.get(Page.mainCategoryProp);
                if (tileMainCategory === currentMainCategory) {
                    return undefined;
                }
                currentMainCategory = tileMainCategory;
                currentSecondaryCategory = '';
                return (
                    <h1>
                        {getCircle()}
                        {tileMainCategory}
                    </h1>
                );
            };

            /**
             *
             * @param {Page} tile
             * @returns {React.JSX}
             */
            const getSecondaryCategoryIfNecessary = (tile) => {
                const tileSecondaryCategory = tile.get(Page.secondaryCategoryProp);
                if (!tileSecondaryCategory || tileSecondaryCategory === currentSecondaryCategory) {
                    return undefined;
                }
                currentSecondaryCategory = tileSecondaryCategory;
                return (
                    <h2>
                        {getCircle()}
                        {tileSecondaryCategory}
                    </h2>
                );
            };

            const handleTileClick = (page) => {
                $.set('Selected Page', page);
                $.trigger('On Tile Click');
            };

            /**
             *
             * @param {Page} page
             * @returns {React.JSX}
             */
            const getTile = (page) => {
                return (
                    <p onClick={() => handleTileClick(page)}>
                        <img width={40} height={40} src={images.get(page.get(Page.imageTagProp))}></img>
                        {page.get(Page.nameProp)}
                    </p>
                );
            };

            // TODO: display the image from the image tag

            return (
                <div className="home-tiles-grid">
                    {(pages || []).map((page) => (
                        <React.Fragment key={page.getTag()}>
                            {getMainCategoryIfNecessary(page)}
                            {getSecondaryCategoryIfNecessary(page)}
                            {getTile(page)}
                        </React.Fragment>
                    ))}
                </div>
            );
        };
    }
}

registerBrick('018c35508760b390ea0c', HomeTiles);
